import React, {Component} from "react"
import PropTypes from "prop-types"
import getEnv from "../../../helpers/common/getEnv"


class LoginPage extends Component {
    _baseWebApp = getEnv('baseAppUrl')

    componentDidMount() {
        window.location.href = `${this._baseWebApp}/ass`
    }

    render() {

        return (
            <div className="LoginPage">
                Loading...
            </div>
        )
    }
}

LoginPage.propTypes = {
    any: PropTypes.any
}

export default LoginPage



// WEBPACK FOOTER //
// ./src/app/pages/login/LoginPage.js